module.exports = __webpack_public_path__ + "img/trip-fuel-operation.35d5c8d5.svg";